module.exports = "/images/congrats-mobile.png?8045ec9d794c5e93e4ddab5446a14676";